import styled, { css } from 'styled-components/macro';
import { Checkbox } from '@yme/atoms/checkbox';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { RequiredProductPart } from '@yme/components/ProductDetailsPage/components/ProductPart/RequiredProductPart';
import { colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const RequiredPartsContainerStyled = styled(FlexWrapper) `
  width: 100%;
  border-radius: ${CORNER_RADIUS.m};
  border: 1px solid ${colorCoreGray500};
`;
export const RequiredPartsHeader = styled(FlexWrapper) `
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid ${colorCoreGray500};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'};
`;
export const RequiredPartsTitle = styled(RegularTextLevel3) `
  font-weight: 500;
  color: ${colorCoreBlack900Base};
`;
export const RequiredPartsContent = styled(FlexWrapper) `
  width: 100%;
  padding: ${({ isRequiredPartsWithItems }) => (isRequiredPartsWithItems ? '0' : '24px 0 32px 0')};

  ${({ withScroll, isScrollable }) => withScroll && isScrollable && CustomScroll}

  max-height: 255px;
`;
export const RequiredProductPartStyled = styled(RequiredProductPart) `
  width: 100%;

  ${({ isScrollable, isRightToLeft }) => isScrollable &&
    css `
      padding: ${isRightToLeft ? '16px 8px 16px 0' : '16px 0 16px 8px'};

      &:first-child {
        padding-top: 8px;
      }

      &:last-child {
        padding-bottom: 8px;
      }
    `}
`;
export const CheckboxStyled = styled(Checkbox) `
  justify-content: center;

  label {
    ${getTextStyles('Ubuntu', 400, 16, null)}

    padding: ${({ isRightToLeft }) => (isRightToLeft ? '0 27px 0 0' : '0 0 0 27px')}
  }
`;
